import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AssetApi } from '../../shared/api/asset.api';
import { HttpClient } from '@angular/common/http';
import { AssetById } from 'app/shared/models/assets.models';

@Component({
  selector: 'asset-search',
  templateUrl: './asset-search.component.html'
})
export class AssetSearchComponent implements OnInit {
  @Input() inputId:string = 'any';
  @Output() asset = new EventEmitter<AssetById>();
  api = new AssetApi(this.http);

  allAssets;
  shownAssets;
  searchString:string = '';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.api.overview().subscribe({next:(data:any[]) => {this.allAssets = data.sort((a,b)=> !!a.modelName && !!b.modelName && a.modelName.toLowerCase() < b.modelName.toLowerCase() ? -1 : 1); this.filter()}});
  }

  filter(){
    let s = this.searchString.toLowerCase();
    this.shownAssets = !s ? this.allAssets : this.allAssets.filter(x => !!x.modelName && x.modelName.toLowerCase().match(s) ||
    !!x.serialNumber && x.serialNumber.toLowerCase().match(s))
  }

  getAsset(asset){
    this.api.assetById(asset.id).subscribe({
      next:(data) => this.asset.emit(data as AssetById)
    })
  }

}
